import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, Divider, FormControl, TextField, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { toast } from 'react-toastify';

interface HardwareDeviceProps {
  node: string;
  type: 'service' | 'endpoint';
  onClose?: () => void | undefined;
  secondaryBtn?: () => void | undefined;
}
const HardwareDevice = ({ node, type = 'endpoint', onClose, secondaryBtn }: HardwareDeviceProps) => {
  const api = useApi();
  const [address, setAddress] = React.useState('');

  const endpointAddress = useMutation(api.setEndpointNodeFormFactorApiV1SetEndpointNodeFormFactorPost, {
    onSuccess() {
      toast.success('Endpoint Node address received.');
      onClose?.();
    },
    onError: apiError,
  });
  const serviceAddress = useMutation(api.setServiceNodeFormFactorApiV1SetServiceNodeFormFactorPost, {
    onSuccess() {
      toast.success('Service Node address received.');
      onClose?.();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    if (type === 'endpoint') {
      endpointAddress.mutate({
        node_id: node,
        form_factor: 'hw',
        shipping_addr: address,
      });
    } else {
      serviceAddress.mutate({
        node_id: node,
        form_factor: 'hw',
        shipping_addr: address,
      });
    }
  };
  return (
    <Box>
      <Typography variant="body1" sx={{ mb: 5 }}>
        Please provide the shipping address for the hardware device.
      </Typography>
      <FormControl fullWidth>
        <TextField
          fullWidth
          label="Shipping Address"
          variant="outlined"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          multiline
          minRows={4}
        />
      </FormControl>
      <Divider sx={{ my: 5, width: '100%' }} />
      <Box display="flex" justifyContent={secondaryBtn ? 'space-between' : 'center'}>
        {secondaryBtn && (
          <Button
            variant="outlined"
            onClick={secondaryBtn}
          >
            Back
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          disabled={address === ''}
          onClick={handleSubmit}
        >
          Save Form Factor
        </Button>
      </Box>
    </Box>
  );
};

export default HardwareDevice;
